export const selectSidebarOpen = (state) => state.ui.sidebar;
export const selectPortal = (state) => state.ui.portal;
export const selectHeaderMenu = (state) => state.ui.headerMenu;
export const selectSmartMenu = (state) => state.ui.smartMenu;